<template>
  <div class="content book-resources">
    <loading v-if="loading" text='Loading. Please wait...'/>
    <div v-show="!loading">
      <h1>Book Resources {{$route.params.id !== 'all' && books.length === 1 ? " for " + books[0].title : ""}}</h1>
      <span v-show="error" class="help is-danger">{{error}}</span>
      <div class="right-tools no-select">
        <Popover placement="bottom" :width="150">
          <div title="Sort Resources" class="drop-down-button" >
            <i class="fal fa-exchange fa-rotate-90"></i>
          </div>
          <div slot="content">
            <div class="sort-drop-down-content">
              <div class="sorting" v-for="sortType in sortTypes" v-bind:key="sortType" v-bind:class="{'sort-active': activeSort === sortType}" v-on:click.stop="toggleSort(sortType)">
                By {{sortType}}
                <slot v-if="activeSort === sortType">
                  <i v-if="reverseSort" class="sort-icon fal fa-chevron-up"></i>
                  <i v-else class="sort-icon fal fa-chevron-down"></i>
                </slot>
              </div>
            </div>
          </div>
        </Popover>
        <BookFilter 
          :books="books" 
          :cache="cache" 
          :popupOptions="booksFilterPopupOptions"
          :booksById="booksById"
          v-if="books.length > 1"
        />
        <ResourceTypesFilter 
          :resourceTypes="resourceTypes" 
          :resourceTypeFiltersApplied="resourceTypeFiltersApplied" 
          :popupOptions="resourceTypesFilterPopupOptions"
        />
        
      </div>
      <div style="clear: both;"></div>

      <Search v-on:searcher="onSearch" :placeholder="'Search'">
      </Search>

      <div v-if="filteredAndSearchedBooks.length === 0" class="no-content-message">
        There are currently no resources to display.
      </div>
      <div>
        <slot v-for="(book, i) in filteredAndSearchedBooks">
          <div v-bind:key="i" v-if="book.hasVisibleResources">
            <div class="book" v-if="$route.params.id === 'all' || books.length !== 1">
              <div class="book-cover"><img :src="$config.get('ecApi') + 'web/books/' + book.id + '/cover?width=200'" alt="coverImage"></div>
              <div class="book-title">{{utils.truncateString(book.title, 115)}}</div>
            </div>
            <slot v-for="(resourceWithAtt, i) in searchedAndFilteredResources(book.items)">
              <div class="book-resource" v-if="detectFilteredIn(resourceWithAtt)" v-bind:key="i" @click="_ => {if (!resourceWithAtt.attachments[0].locked) openResource(resourceWithAtt, resourceWithAtt.resource, resourceWithAtt.attachments)}" :class="{'overlay':resourceWithAtt.attachments[0].locked}">
                <!-- <router-link :to="'resource/' + resource.code" v-for="(resource, i) in bookResources" v-bind:key="i" -->
                  <span class="unread is-pulled-right" title="Resource not viewed yet" v-if="resourceWithAtt.isUnread"></span>
                  <div class="image-left-cell">
                    <img class="resource-type" :src="($config.get('basePathFiles') + (utils.resourceTypeImg(getResourceCategory(resourceWithAtt), resourceWithAtt.resource.url)))" />
                  </div>
                  <div class="book-information">
                    <span :data-id="resourceWithAtt.resource._id" class="resource-title">{{resourceWithAtt.displayTitle}}<br></span>
                    <span class="added-date">Added {{utils.getDate(resourceWithAtt.resource.created)}}<br></span>
                    <InLocations :book="book" :resource="resourceWithAtt" :attachments="resourceWithAtt.attachments"/>
                  </div>
                <!-- </router-link> -->
              </div>
            </slot>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import storeHelpers from '@/utils/storeHelpers.js';

  import ResourceTypesFilter from '@/components/widgets/filters/ResourceTypesFilter';
  import BookFilter from '@/components/widgets/filters/BookFilter';

  import Popover from '@/components/widgets/popover'
  import InLocations from '@/components/widgets/InLocations'

  import analytics from '@/utils/analytics.js';
  import Search from '@/components/widgets/Search'; 
  
  export default {
    name: 'BookResources',
    components: {
      ResourceTypesFilter,
      BookFilter,
      Popover,
      Search,
      InLocations
    },
    data: function () {
      var t = this;

      return {
        sortTypes: ['name', 'date', 'type'],
        loading: true,
        resourcesById: {},
        attachments: [],
        utils: utils,
        storeHelpers: storeHelpers,
        resourceTypes: {},
        error: '',
        books: [],
        booksById: {},
        cache: {
          booksFilteredOut: new Set(null)
        },
        search: '',
        bookFilterSearch: '',
        booksFilterSelectAllText: 'Deselect all',
        bookFilterPopupActive: false,
        resourceTypesFilterPopupOptions: {
          active: false
        },
        booksFilterPopupOptions: {
          active: false
        },
        activeSort: 'name',
        reverseSort: false,
        unwatchFunctions: []
      }
    },
    destroyed: function() {
      _.each(this.unwatchFunctions, function(unwatchFunction) {
        unwatchFunction();
      });
    },
    mounted: function () {
      this.updateSettings();
      this.resourceTypes = utils.getAllResourceTypes(['flashcarddeck', 'note', 'sketch', 'googledrive', 'drawing']);
      _.each(this.resourceTypes, function(type) {
        Vue.set(type, 'filteredIn', true);
      });

      storeHelpers.checkActive(this);

      this.unwatchFunctions = utils.watchStorePropertiesWithCallback(this, ['bookList', 'resources', 'attachments', 'netch'], this.bookResourcesUpdated);
      analytics.resources(this);
    },
    computed: {
      filteredAndSearchedBooks() {
        var t = this;
        return t.books.filter(book => {
          return book.filteredIn && t.searchedAndFilteredResources(book.items).length > 0;
        })
      }      
    },    
    methods: {
      onSearch: function(val) {
        this.search = val;
      },
      openResource(resourceWithAtt, resource, attachments) {
        var t = this;
        storeHelpers.checkActive(this);
        utils.openResource(this, resource, _.map(attachments, function(attachment) {
          storeHelpers.markAsRead(t, resource, attachment);
          resourceWithAtt.isUnread = false;
          return attachment._id
        }), {"from":"br"});
      },
      searchedAndFilteredResources: function (items) {
        var t = this;
        return _.filter(items, function(resourceWithAtt) {          
          if (resourceWithAtt.resource.category === "flashcarddeck") {
            if (resourceWithAtt.resource.private) {
              return t.resourceTypes && t.resourceTypes.personalflashcarddeck && t.resourceTypes.personalflashcarddeck.filteredIn && resourceWithAtt.displayTitle.toLowerCase().includes(t.search.toLowerCase()) && t.attachmentIsVisible(resourceWithAtt)
            } else if (!resourceWithAtt.resource.private) {
              return t.resourceTypes && t.resourceTypes.educatorflashcarddeck && t.resourceTypes.educatorflashcarddeck.filteredIn && resourceWithAtt.displayTitle.toLowerCase().includes(t.search.toLowerCase()) && t.attachmentIsVisible(resourceWithAtt)
            }
          }
          //resourceWithAtt.attachments = utils.filterLockedResources(t, resourceWithAtt.attachments);
          return t.resourceTypes && resourceWithAtt.resource.category && t.resourceTypes[resourceWithAtt.resource.category] && t.resourceTypes[resourceWithAtt.resource.category].filteredIn && resourceWithAtt.displayTitle.toLowerCase().includes(t.search.toLowerCase()) && t.attachmentIsVisible(resourceWithAtt);
        })
      },
      attachmentIsVisible: function (resourceWithAtt) {
        var t = this;
        var a = _.filter(resourceWithAtt.attachments, att => {
          return att.visible;
        }).length > 0;
        return a
      },
      resourceTypeFiltersApplied: function () {
        var t = this;
        _.each(t.books, function(book) {
          var totalResources = book.items.length;
          _.each(book.items, function(resourceWithAtt) {
            if (t.resourceTypes && resourceWithAtt.resource.category && t.resourceTypes[resourceWithAtt.resource.category] && !t.resourceTypes[resourceWithAtt.resource.category].filteredIn) {
              totalResources -= 1;
            }
          });

          Vue.set(book, 'hasVisibleResources', totalResources > 0);
        });
      },
      bookResourcesUpdated: function (property, value) {
        var t = this;
        t.loading = false;
        var bookList = t.$store.state.bookList;

        if(t.$route.params.id !== 'all') {
          bookList = _.filter(bookList, function(book) {
            return book.id === t.$route.params.id;
          });
        }

        // only do this the first time
        _.each(bookList, function(book) {
          if(property === 'init') {
            Vue.set(book, 'filteredIn', true);
          } else { 
            // restore cache
            Vue.set(book, 'filteredIn', !t.cache.booksFilteredOut.has(book.id));
          }
          Vue.set(book, 'items', []);
        });
        t.books = _.orderBy(bookList, [ function(book) { return book.title.trim().toLowerCase();} ], ['asc']);
        t.attachments = utils.filterLockedResources(t, t.$store.state.attachments);

        // _.each(t.attachments, att => {
        //   if (att && att.locked === undefined) {
        //     att = utils.filterLockedResources(t, att)
        //   }
        // })

        t.booksById = _.keyBy(t.books, "id");
        t.resourcesById = _.keyBy(t.$store.state.resources, "_id");

        const resourcesPerBook = storeHelpers.getResourcesPerBookNoAnnotations(this);
        _.each(Object.keys(resourcesPerBook), function(bookId) {
          if(t.booksById[bookId]) {
            Vue.set(t.booksById[bookId], 'items', resourcesPerBook[bookId]);
          }
        })

        t.resourceTypeFiltersApplied();
        t.sortByName()
      },
      calculateFilterButtonText: function (list) {
        var allFilteredIn = false;
        if (list.length !== undefined)
          allFilteredIn = _.countBy(list, 'filteredIn')['true'] === list.length;
        else
          allFilteredIn = _.countBy(list, 'filteredIn')['true'] === Object.keys(list).length;
        return allFilteredIn ? "Deselect all" : "Reset filters";
      },
      toggleSort: function(sortType) {
        this.reverseSort = this.activeSort === sortType ? !this.reverseSort : false;
        this.activeSort = sortType;

        if(sortType === 'name') {
          this.sortByName();
        } else if(sortType === 'type') {
          this.sortByType();
        } else if(sortType === 'date') {
          this.sortByDate();
        }
      },
      sortByName: function() {
        var t = this;
        _.each(t.books, function (book) {
          if (book.items) {
            book.items = _.orderBy(book.items, [ function(item) {
              return item.displayTitle.trim().toLowerCase();
            }], [t.reverseSort ? 'desc' : 'asc']);
          }
        })
        t.saveSettings(t.reverseSort, undefined, undefined)
      },
      sortByDate: function() {
        var t = this;
        _.each(t.books, function (book) {
          if (book.items) {
            book.items = _.orderBy(book.items, [ function(item) {
              return item.resource.created;
            }], [t.reverseSort ? 'desc' : 'asc']);
          }
        })
        t.saveSettings(undefined, t.reverseSort, undefined)
      },
      sortByType: function() {
        var t = this;
        _.each(t.books, function (book) {
          if (book.items) {
            book.items = _.orderBy(book.items, [ function(item) {
              return item.resource.category;
            }], [t.reverseSort ? 'desc' : 'asc']);
          }
        })
        t.saveSettings(undefined, undefined, t.reverseSort)
      },
      detectFilteredIn: function(resourceWithAtt) {
        if (resourceWithAtt.resource.category === "flashcarddeck") {
          if (resourceWithAtt.resource.private) {
            return resourceWithAtt.resource && this.resourceTypes.personalflashcarddeck.filteredIn;
          } else if (!resourceWithAtt.resource.private) {
            return resourceWithAtt.resource && this.resourceTypes.educatorflashcarddeck.filteredIn;
          }
        }
        return resourceWithAtt.resource && this.resourceTypes[resourceWithAtt.resource.category].filteredIn;
      },
      getResourceCategory: function(resourceWithAtt) {
        if (resourceWithAtt.resource.category === "flashcarddeck") {
          if (resourceWithAtt.resource.private) {
            return "personalflashcarddeck";
          } else {
            return "educatorflashcarddeck";
          }
        }
        return resourceWithAtt.resource.category;
      },
      updateSettings: function() {
        // check state if settings set
        var bookResourcesSettings = storeHelpers.getUserPreferences(this, "bookResources");
        if (bookResourcesSettings) {
          if (bookResourcesSettings.sortByName !== undefined) {
            this.reverseSort = bookResourcesSettings.sortByName;
            this.activeSort = "name";
            this.sortByName();
          } else if (bookResourcesSettings.sortByDate !== undefined) {
            this.reverseSort = bookResourcesSettings.sortByDate;
            this.activeSort = "date";
            this.sortByDate();
          } else if (bookResourcesSettings.sortByType !== undefined) {
            this.reverseSort = bookResourcesSettings.sortByType;
            this.activeSort = "type";
            this.sortByType();
          } else {
            this.activeSort = "name";
            this.sortByName();
          }
        }
      },
      saveSettings: function(sortByName, sortByDate, sortByType) {
        var bookResourcesObj = {}
        if (sortByName !== undefined) {
          bookResourcesObj = {
            "sortByName" : sortByName
          }
        } else if (sortByDate !== undefined) {
          bookResourcesObj = {
            "sortByDate" : sortByDate
          }
        } else if (sortByType !== undefined) {
          bookResourcesObj = {
            "sortByType" : sortByType
          }
        }
        storeHelpers.setUserPreferences(this, "bookResources", bookResourcesObj);
      }
    }
  }
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.book-resources {
  .unread {
    float: right;
    width: 15px;
    height: 15px;
    vertical-align: top;
    margin-top: 30px;
  }
}

.list-item {
  height: 90px
}

.book {
  text-align: left;
  background: transparent;
  display: table;
  width: 100%;
  font-weight: bold;
  background: $background-color-darkest;
  margin-top: 0;
  padding: 0;
  cursor: default;
}

.resource-type {
  width: 32px;
  float: left;
  margin-top: 20px;
  margin-right: 10px;
  margin-left: 7px;
}

.added-date {
  color: $dark-font-color-lighter;
  font-size: 10pt;
}

.book-resource {
  text-align: left !important;
  border-bottom: 1px solid $border-color;
  height: 95px;
  width: 100%;
  padding: 10px 5px;
}

.book-resource:hover {
  background: $background-color-dark;
  cursor: pointer;
}

.book-cover {
  display: table-cell;
  width: 70px;
  padding: 10px;
}

.book-title {
  vertical-align: middle;
  display: table-cell;
  color: white;
}

.sorting {
  padding: 5px;
  font-size: 12pt;
}

.sort-icon {
  margin-left: 10px;
}

.sort-active {
  color: $primary;
}

.image-left-cell {
  margin-right: 10px;
}

.book-information {
  display: inline-block;
  max-width: calc(100vw - 140px);
  vertical-align: top;
  margin-left: 15px;
}

.resource-title {
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
  font-size: 11pt;
}

@media only screen and (max-width: 600px) {
  .filter-drop-down-content {
    min-width: 300px;
    left: -306px;
  }
}

</style>